import { Box, MenuItem, Paper, Select } from '@/shared/ui';

import SeasonalChartIcon from '@/assets/icons/SeasonalChart';
import SimpleChartIcon from '@/assets/icons/SimpleChart';
import { DEFAULT_SEASONAL_YEARS } from '@/features/dashboard/components/AppForm/AppForm/components/SelectSeasonalRange';
import { useAppForm } from '@/features/dashboard/components/AppForm/AppForm/context';
import { AppType } from '@/features/dashboard/types';
import Typography from '@/shared/ui/typography/Text';

const ChartTypeLabel = ({
  icon,
  type,
  info
}: {
  icon: React.ReactNode;
  type: string;
  info: string;
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
      {icon}
      <Typography size={14}>{type}</Typography>
      <Typography
        size={12}
        sx={{ fontWeight: 500, color: 'gx.textDisabled' }}
      >
        {info}
      </Typography>
    </Box>
  );
};

const items = [
  {
    value: AppType.Spot,
    label: (
      <ChartTypeLabel
        icon={<SimpleChartIcon />}
        info='Up to 6 items'
        type='Spot History chart'
      />
    )
  },
  {
    value: AppType.Seasonal,
    label: (
      <ChartTypeLabel
        icon={<SeasonalChartIcon />}
        info='1 item only'
        type='Seasonal chart'
      />
    )
  }
];

export const SelectChartType = () => {
  const { form } = useAppForm();
  return (
    <form.Field
      children={field => (
        <Box
          component={Paper}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            p: 2,
            width: '100%',
            gap: 1
          }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: '14px' }}>Chart type</Typography>
          <Typography sx={{ fontWeight: 500, fontSize: '12px', color: 'gx.textDisabled', mb: 1 }}>
            Select the type of chart you want to create
          </Typography>
          <Select
            sx={{
              '& fieldset': { borderColor: 'gx.text !important' },
              '&:hover fieldset': { borderColor: 'gx.text !important' },
              '&.Mui-focused fieldset': { borderColor: 'gx.text !important' }
            }}
            value={field.state.value}
            onChange={e => {
              const nextType = e.target.value as AppType;
              field.handleChange(nextType as never);
              const values = form.state.values;
              const hasName = !!values && 'name' in values;
              const currentName = hasName ? values.name : undefined;
              if (nextType === AppType.Seasonal) {
                if (!form.getFieldValue('from')) {
                  form.setFieldValue('from', DEFAULT_SEASONAL_YEARS);
                }
                if (hasName && currentName === 'Spot History chart') {
                  form.setFieldValue('name', 'Seasonal chart');
                }
              } else if (nextType === AppType.Spot && hasName && currentName === 'Seasonal chart') {
                form.setFieldValue('name', 'Spot History chart');
              }
            }}
          >
            {items.map(item => (
              <MenuItem
                key={item.value}
                value={item.value}
              >
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}
      name='type'
    />
  );
};
